<template>
	<div>
		Questionnaire analysis {{ id }}
	</div>
</template>

<script>
export default {
	name: 'response-overview',

	props: {
		id: {
			type: String
		}
	}
}
</script>
